import { CardMedia } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getFilePreview } from 'store/slices/files';
import { LayersOutlined } from '@mui/icons-material';

const TemplateCardPreviewComponent = ({ previewId = '', name = '' }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [preview, setPreview] = useState('');

  useEffect(() => {
    let isMounted = true;
    const fetchPreview = async () => {
      setIsLoading(true);
      try {
        const data = await dispatch(getFilePreview({ id: previewId })).unwrap();
        if (isMounted) setPreview(data);
      } catch (error) {
        if (isMounted) setPreview('');
        console.error(error);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    if (previewId) {
      fetchPreview();
    } else {
      setPreview('');
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, previewId]);

  if (!isLoading && previewId && preview) {
    return (
      <CardMedia
        component="img"
        sx={{ height: '100%', objectFit: 'contain' }}
        image={preview}
        alt={name}
        loading="lazy"
      />
    );
  }

  if (!isLoading && !preview) {
    return <LayersOutlined />;
  }

  return null;
};

export const TemplateCardPreview = memo(
  TemplateCardPreviewComponent,
  (prevProps, nextProps) => prevProps.previewId === nextProps.previewId
);

TemplateCardPreview.displayName = 'TemplateCardPreview';
